import { useEffect } from 'react';
import { useSocketStore } from '../../stores/useSocketStore';
import { useTurnosStore } from '../../stores/useTurnosStore';

export function useTurnosSocket() {

    const socket = useSocketStore(state => state.socket);

    useEffect(() => {

        if (!socket) {
            return;
        }

        let disposed = false;

        // =========================
        // CONTROLE DE REQUESTS
        // =========================

        const requests = {
            turnos: {
                loading: false,
                pending: false
            },

            codes: {
                loading: false,
                pending: false
            }
        };

        // =========================
        // CARREGA TURNOS
        // =========================

        const loadTurnos = () => {

            const state = requests.turnos;

            if (state.loading) {

                state.pending = true;

                return;
            }

            if (!socket.connected) {
                return;
            }

            state.loading = true;
            state.pending = false;

            socket.timeout(10000).emit(
                'turnos:get',
                {},
                (err, response) => {

                    state.loading = false;

                    if (disposed) {
                        return;
                    }

                    if (
                        !err &&
                        response?.ok &&
                        Array.isArray(response.turnos)
                    ) {

                        useTurnosStore
                            .getState()
                            .setTurnos(response.turnos);

                    } else {

                        console.error(
                            'Erro ao carregar turnos:',
                            err || response?.message
                        );

                    }

                    if (state.pending) {

                        state.pending = false;

                        loadTurnos();

                    }

                }
            );

        };

        // =========================
        // CARREGA TURNOS CODES
        // =========================

        const loadTurnosCodes = () => {

            const state = requests.codes;

            if (state.loading) {

                state.pending = true;

                return;
            }

            if (!socket.connected) {
                return;
            }

            state.loading = true;
            state.pending = false;

            socket.timeout(10000).emit(
                'turnos-codes:get',
                {},
                (err, response) => {

                    state.loading = false;

                    if (disposed) {
                        return;
                    }

                    if (
                        !err &&
                        response?.ok &&
                        Array.isArray(response.turnosCodes)
                    ) {

                        useTurnosStore
                            .getState()
                            .setTurnosCodes(response.turnosCodes);

                    } else {

                        console.error(
                            'Erro ao carregar turnos-codes:',
                            err || response?.message
                        );

                    }

                    if (state.pending) {

                        state.pending = false;

                        loadTurnosCodes();

                    }

                }
            );

        };

        // =========================
        // INVALIDATE
        // =========================

        const handleTurnosInvalidate = () => {

            loadTurnos();

        };

        const handleTurnosCodesInvalidate = () => {

            loadTurnosCodes();

        };

        // =========================
        // LISTENERS
        // =========================

        socket.on('turnos:invalidate', handleTurnosInvalidate);

        socket.on('turnos-codes:invalidate', handleTurnosCodesInvalidate);

        // =========================
        // CLEANUP
        // =========================

        return () => {

            disposed = true;

            socket.off('turnos:invalidate', handleTurnosInvalidate);

            socket.off('turnos-codes:invalidate', handleTurnosCodesInvalidate);

        };

    }, [socket]);

}